const FAQData = [
  {
    question: 'Cos’è il telemonitoraggio?',
    answer:
      'Il telemonitoraggio è un servizio che ti consente di monitorare la tua salute a distanza, inviando dati vitali al tuo medico.',
  },
  {
    question: 'Quali dati vengono monitorati?',
    answer:
      'Monitoriamo parametri come pressione sanguigna, frequenza cardiaca, saturazione di ossigeno, elettrocardiogramma e altri dati rilevanti.',
  },
  {
    question: 'Come posso accedere ai miei dati?',
    answer:
      'Puoi visualizzare i tuoi dati direttamente nella home page dell’app e nella sezione storico.',
  },
  {
    question: 'Chi può vedere i miei dati?',
    answer:
      'Solo il tuo medico curante e il suo team sanitario autorizzato possono accedere ai tuoi dati.',
  },
  {
    question: 'Cosa devo fare se ricevo un alert?',
    answer:
      'L’app ti guiderà ogni volta che riceverai un alert. Inoltre il tuo caregiver, il medico e la sua equipe riceveranno una notifica immediata.',
  },
  {
    question: 'Posso modificare le impostazioni dei dispositivi medici?',
    answer:
      'I dispositivi medici sono già pre-impostati correttamente dal tuo medico, non c’è bisogno di apportare alcuna modifica.',
  },
  {
    question: 'È sicuro condividere i miei dati tramite l’app?',
    answer:
      'Sì, i tuoi dati sono criptati e protetti secondo gli standard di sicurezza più elevati. Ti consigliamo di leggere la sezione privacy se vuoi sapere di più.',
  },
  {
    question: 'Come posso contattare il supporto?',
    answer:
      'Puoi contattare il supporto direttamente dall’app tramite chat o telefonando al 02-3859 2671.',
  },
  {
    question: 'I dispositivi medici funzionano ovunque?',
    answer:
      'I dispositivi medici funzionano ovunque se sono nel raggio di 10 metri dalla chiavetta USB e dal tablet e se il tablet ha una buona ricezione internet.',
  },
  {
    question: 'Posso interrompere il telemonitoraggio in qualsiasi momento?',
    answer:
      'Sì, ma ti consigliamo di parlarne prima con il tuo medico per valutare le conseguenze.',
  },
  {
    question: 'L’app funziona senza connessione internet?',
    answer:
      'No, è necessaria una connessione internet per inviare i dati e ricevere notifiche.',
  },
];

export default FAQData;